/* ---------------------------------- */
/* TIME UTILS */
/* ---------------------------------- */

import {
    DateTime,
} from "luxon";

import {
    BUSINESS_TZ,
} from "./timeUtils";

/* ---------------------------------- */
/* CART HELPERS */
/* ---------------------------------- */

export function hasCartConflict(
    cartItems,
    date,
    startHour
) {

    return cartItems.some(

        (item) =>

            item.date === date &&

            item.startHour === startHour
    );
}

export function getTotalDurationForDate(
    cartItems,
    date
) {

    return cartItems

        .filter(
            (item) =>
                item.date === date
        )

        .reduce(

            (sum, item) =>

                sum + item.duration,

            0
        );
}

export function exceedsDailyLimit(
    cartItems,
    date,
    duration,
    limit = 2
) {

    const current =
        getTotalDurationForDate(

            cartItems,

            date
        );

    return (
        current + duration >
        limit
    );
}

/* ---------------------------------- */
/* FORMAT HOUR */
/* ---------------------------------- */

export function formatHour(
    hour
) {

    return `${String(hour).padStart(2, "0")}:00`;
}

/* ---------------------------------- */
/* GET SLOT DATETIME IN ET */
/* ---------------------------------- */

export function getSlotDateTimeET(
    date,
    hour
) {

    return DateTime.fromISO(

        `${date}T${String(hour).padStart(2, "0")}:00:00`,

        {
            zone:
                BUSINESS_TZ,
        }
    );
}

/* ---------------------------------- */
/* MERGE CONTINUOUS SLOTS */
/* ---------------------------------- */

export function mergeContinuousSlots(
    slots = []
) {

    if (!slots.length) {

        return [];
    }

    /* ---------------------------------- */
    /* SORT */
    /* ---------------------------------- */

    const sorted =
        [...slots].sort(

            (a, b) => {

                /* DATE */

                if (
                    a.date !== b.date
                ) {

                    return a.date.localeCompare(
                        b.date
                    );
                }

                /* COURT */

                if (
                    a.courtName !==
                    b.courtName
                ) {

                    return a.courtName.localeCompare(
                        b.courtName
                    );
                }

                /* START HOUR */

                return (
                    Number(a.startHour) -
                    Number(b.startHour)
                );
            }
        );

    const merged = [];

    /* ---------------------------------- */
    /* MERGE */
    /* ---------------------------------- */

    for (
        const slot
        of sorted
    ) {

        const last =
            merged[
            merged.length - 1
            ];

        const canMerge =

            last &&

            /* SAME DATE */

            last.date ===
            slot.date &&

            /* SAME COURT */

            last.courtName ===
            slot.courtName &&

            /* SAME LOCATION */

            last.location ===
            slot.location &&

            /* CONTINUOUS */

            Number(last.endHour) ===
            Number(slot.startHour);

        /* ---------------------------------- */
        /* MERGE */
        /* ---------------------------------- */

        if (canMerge) {

            last.endHour =
                slot.endHour;

            last.duration +=
                slot.duration || 1;

            last.price +=
                slot.price || 0;

            last.timeSlot =

                `${formatHour(last.startHour)} - ${formatHour(last.endHour)}`;

        } else {

            merged.push({

                ...slot,
            });
        }
    }

    return merged;
}

/* ---------------------------------- */
/* FLATTEN UPCOMING SLOTS */
/* ---------------------------------- */

export function flattenUpcomingBookings(
    bookings = []
) {

    const allSlots = [];

    bookings.forEach((booking) => {

        const mergedSlots =
            mergeContinuousSlots(
                booking.slots || []
            );

        mergedSlots.forEach((slot) => {

            allSlots.push({

                ...slot,

                bookingId:
                    booking.bookingId,

                totalAmount:
                    booking.totalAmount,

                bookingStatus:
                    booking.bookingStatus,
            });
        });
    });

    return allSlots.sort(

        (a, b) => {

            const aDate =
                getSlotDateTimeET(
                    a.date,
                    a.startHour
                );

            const bDate =
                getSlotDateTimeET(
                    b.date,
                    b.startHour
                );

            return (
                aDate.toMillis() -
                bDate.toMillis()
            );
        }
    );
}